<!-- eslint-disable no-unused-vars -->
<template>
  <div class="containers">
    <div
      id="reader-container"
      style="position: absolute; z-index: -1; width: 100%; top: 50%; left: 50%; -ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);"
    >
      <div id="reader" style="background: black;"></div>
    </div>
    <transition name="tipMsg">
      <div class="tip-msg" v-if="showTip">
        {{ tipMsg }}
      </div>
    </transition>
    <transition name="successTipMsg">
      <div class="tip-msg-success" v-if="showSuccessTip">
        {{ successTipMsg }}
      </div>
    </transition>
    <!--        <img src="../assets/image/barcode/loading.png" alt="">-->
    <div class="loading" v-if="loading">
      <div>
        <svg
          class="loading-spinner"
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          viewBox="0 0 512 512"
          fill="#FFF"
        >
          <!-- !Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. -->
          <path
            d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
          />
        </svg>
      </div>
      <p>
        {{ $t("barCode.Loading") }}
      </p>
    </div>
    <div
      class="mask"
      :style="{ opacity: maskOpacity, 'z-index': maskIndex }"
    ></div>
    <div id="video"></div>
    <div id="qr-reader" style="width:100%"></div>
    <div id="c-control"></div>
    <div class="content">
      <!-- <p class="tip-content" v-if="isNeedScanOtherNumber">{{ $t("barCode.PleaseAimBarcode") }}</p>
      <p class="tip-content" v-else>{{ $t("barCode.PleaseAim") }}</p> -->
      <p class="tip-content" v-if="flow=='WITH_LABEL'">{{ $t("barCode.PleaseAimWithLabel") }}</p>
      <!-- <p class="tip-content" v-else-if="flow=='WITHOUT_LABEL' && step=='1'" v-html="$t('barCode.PleaseAimWithoutLabel1')"></p>-->
      <!-- <p class="tip-content" v-else-if="flow=='WITHOUT_LABEL' && step=='2'" v-html="$t('barCode.PleaseAimWithoutLabel2')"></p>-->
      <div class="tip-content stepper-container" v-else-if="flow=='WITHOUT_LABEL' && (step=='1' || step=='2')" >
        <div class="circle" :class="{ active: step=='1', completed: step==='2' }">
          <svg v-if="step=='2'" width="16" height="16" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.3754 0.812183C18.4279 -0.265102 20.1405 -0.271531 21.2007 0.797867C22.2609 1.8673 22.2672 3.60756 21.2148 4.68486L8.20668 18L0.795601 10.4957C-0.26258 9.42417 -0.265579 7.68393 0.788909 6.60868C1.8434 5.53343 3.55601 5.53038 4.6142 6.60188L8.1859 10.2185L17.3754 0.812183Z" fill="#0055FF"/>
          </svg>
          <p v-else>1</p>
        </div>
        <div class="stepper-text">{{ $t("barCode.withoutLabelStep1Text") }}</div>
        <div class="stepper-line"></div>
        <div class="circle" :class="{ active: step=='2' }">2</div>
        <div class="stepper-text">{{ $t("barCode.withoutLabelStep2Text") }}</div>
      </div>
      <p class="tip-content" v-else>{{ $t("barCode.PleaseAimBarcode") }}</p>

      <div class="scan-box" id="reader">
        <div class="scan-line"></div>
      </div>

      <p class="tip-content-bottom" v-if="flow=='WITHOUT_LABEL' && step=='1'" v-html="$t('barCode.ScanMessageWithoutLabelStep1Text')"></p>
      <p class="tip-content-bottom" v-else-if="flow=='WITHOUT_LABEL' && step=='2'" v-html="$t('barCode.ScanMessageWithoutLabelStep2Text')"></p>

      <p v-if="enterBar" class="manually" @click="tiaoZhuan()">
        {{
          flow=='WITHOUT_LABEL' && step=='1' ? $t("barCode.manuallyWITHOUT_LABEL") : 
          flow=='WITHOUT_LABEL' && step=='2' ? $t("barCode.manuallyWithoutLabelStep2") : 
          $t("barCode.manually")
        }}
      </p>
      <!-- <router-link to="/index"> -->
        <div class="back" @click="back()">
          <span class="back-font">{{ $t("common.Back") }}</span>
        </div>
      <!-- </router-link> -->
      <canvas
        id="canvas"
        width="800"
        height="350"
        style="display: none"
      ></canvas>
      <div class="confirmMiniLabel" v-if="confirmMiniLabel">
        <p>{{ $t("barCode.confirmMiniLabelText") }}</p>
        <p>{{ scanResult }}</p>
        <div>
          <button class="details_bt_w" @click="cancel()">{{$t('common.reScan')}}</button>
          <button class="details_bt_b" @click="confirm()">{{$t('common.Confirm')}}</button>
        </div>
      </div>
    </div>
    <!--        <div id="msg" v-for="tip in msg">{{tip}}</div>-->
  </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'

export default {
  beforeRouteLeave (to, from, next) {
    // 离开路由后清空循环操作
    clearInterval(this.scanImage)
    clearInterval(this.scanAction)
    next()
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    document.removeEventListener('visibilitychange', self.handleVisibilityChange);
    this.clearCamera()
    clearInterval(this.loopCheckIndex)
    this.bDestroyed = true
    if (this.scanner) {
      this.scanner.destroy()
    }
  },
  name: 'Barcode',
  data () {
    return {
      lastResult: null,
      html5QrcodeScanner: null,
      msg: ['初始化界面'],
      maskOpacity: 0, // 蒙版不透明度
      maskIndex: -1, // 蒙版层级
      scanImage: null, // 截取视频为图片，然后解析图片。定时任务
      scanAction: null, // 扫码特效
      constraints: { video: { facingMode: 'environment' } }, // 只开启摄像头，并且强制使用后置摄像头
      action: null, // 本页面要执行的操作
      pin: null, // 取件碼
      loading: false, // loading字样
      enterBar: true, // 是否允许手动输入条形码
      actionList: {
        parcelInfo: true,
        collectingPointStoreExpress: true,
        collectingPointTakeExpress: true,
        merchantTakeExpress: true,
        collectExpiredExpress: true,
        scanNote: true
      },
      playVideo: true,
      scanResult: null, // 扫码结果
      checkCodeOrderID: null,
      orderIdArr: [],
      checkedOrderId: false,
      showTip: false,
      showSuccessTip: false,
      tipMsg: null,
      successTipMsg: null,
      bDestroyed: false,
      scanner: null,
      loopCheckIndex: null,
      isNeedScanOtherNumber: false,
      oldScanResult: '',
      otherNumber: '',
      flow: '',
      step: 1,
      confirmMiniLabel:false
    }
  },
  beforeCreate () {
    // 检测是否是IOS
    let IOS = this.commonJS.isIOS
    // if (IOS) {
    //   this.$router.push('/ios/barcode')
    //   return false
    // }
  },
  created () {},
  beforeMount () {},
  mounted () {
    this.flow = this.$route.query.flow
    this.step = this.$route.query.step
    if (this.$route.query.isNeedScanOtherNumber) {
      this.isNeedScanOtherNumber = this.$route.query.isNeedScanOtherNumber
      this.oldScanResult = this.$route.query.oldScanResult
      this.otherNumber = this.$route.query.otherNumber
    }
    let s_width = document.documentElement.clientWidth
    let s_height = document.documentElement.clientHeight
    console.log('当前屏幕宽度：', s_width)
    console.log('当前屏幕高度：', s_height)

    let self = this
    // 检测API权限
    if (
      navigator.mediaDevices === undefined ||
      navigator.mediaDevices.getUserMedia === undefined
    ) {
      alert('當前瀏覽器版本不支持攝像功能！')
      this.$router.back()
    }

    // 检测摄像设备
    let constraints = {
      width: { min: 1280, ideal: 1920, max: 1920 },
      height: { min: 720, ideal: 1080, max: 1080 },
      facingMode: 'environment'
    }
    constraints = {
      audio: false,
      video: {
        width: { min: 720, max: 1080, ideal: 1080 },
        height: { min: 1280, max: 1920, ideal: 1920 }
      },
      facingMode: 'environment'
    }
    //navigator.mediaDevices
    //  .getUserMedia(constraints)
    //  .then(function (mediaStream) {
    //    return false
    //  })
    //  .catch(function (err) {
    //    if (err.message === 'Permission denied') {
    //      alert(this.$t('barCode.noPermission'))
    //    }
    //    if (err.message === 'Requested device not found') {
    //      alert(this.$t('barCode.nofind'))
    //    }
    //  })

    // 获取设备
    //navigator.mediaDevices
    //  .enumerateDevices()
    //  .then(function (devices) {
    //    console.log(devices)
    //    devices.forEach(function (device) {
    //      console.log(
    //        device.kind + ': ' + device.label + ' id = ' + device.deviceId
    //      )
    //    })
    //  })
    //  .catch(function (err) {
    //    console.log(err.name + ': ' + err.message)
    //  })

    this.pin = this.$route.query.pin

    //const html5QrCode = new Html5Qrcode('reader')
    //self.html5QrCode = html5QrCode

    // 启动特效
    // this.scanAction = this.scan()
    // 获取当前要操作的行为
    // this.msg.push('获取行为')
    this.action = this.$route.query.action
    this.original_action = this.$route.query.original_action
    let action = this.action
    // 某些操作需要做处理，隐藏输入
    if (action === 'scanNote') {
      // 隐藏输入按钮
      this.enterBar = false
    }
    // 判断是否是允许的操作
    let res = this.actionList
    if (!res[action]) {
      alert('Unknown operation')
      // 未知的操作直接返回
      this.$router.back()
      return false
    }
    this.loopCheck()
    //this.startQua()
    
    //this.getCameraStream()
    //this.startHtml5QrcodeScanner()
    setTimeout(()=>{
      self.getCameraStream()
    }, 200)

    document.addEventListener('visibilitychange', self.handleVisibilityChange);
  },
  methods: {
    handleVisibilityChange() {
      var self = this
      if (document.visibilityState === 'hidden') {
        self.clearCamera()
      } else if (document.visibilityState === 'visible') {
        self.reloadPage();
      }
    },
    async getCameraStream() {
      let self = this
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });

        if (stream && typeof stream.getTracks === "function") {
          //stream.getTracks().forEach(track => alert(`Track kind: ${track.kind}, readyState: ${track.readyState}`));
          stream.getTracks().forEach(track => track.stop());
        }
      } catch (err) {
        console.error("Error accessing the camera: " + err);
        // Handle permission denied or camera busy errors here
      } finally {
        self.startHtml5QrcodeScanner();
      }
    },
    onScanSuccess(decodedText, decodedResult) {
      let vue = this
      let lastResult = vue.lastResult
      if (decodedText !== lastResult) {
        lastResult = decodedText;
        console.log(`Scan result = ${decodedText}`, decodedResult);

        //alert(decodedText);
        vue.scanResult = decodedText
        
        // Optional: To close the QR code scannign after the result is found
        //vue.html5QrcodeScanner.clear();
      }
    },
    onScanError(qrCodeError) {
        // This callback would be called in case of qr code scan error or setup error.
        // You can avoid this callback completely, as it can be very verbose in nature.
    },
    reloadPage () {
      window.location.reload()
    },
    loopCheck () {
      let vue = this
      vue.loopCheckIndex = setInterval(function () {
        if (vue.scanResult) {
          //vue.pauseCamera()

          clearInterval(vue.loopCheckIndex)
          vue.startMask()
          vue.parseCode()
        }
      }, 1000)
    },
    async startQua () {
      let backCamID

      const devices = await navigator.mediaDevices.enumerateDevices()
      devices.forEach(function (device) {
        console.log(JSON.stringify(device))
        if (
          device.kind === 'videoinput' &&
          device.label.match(/back/) != null
        ) {
          // alert("Back found!");
          backCamID = device.deviceId
        }
      })
      let vue = this
      vue.startCamera(backCamID)

      // let vue = this
      // let isIOS = this.commonJS.isIOS
      // Html5Qrcode.getCameras().then(devices => {
      //   /**
      //    * devices would be an array of objects of type:
      //    * { id: "id", label: "label" }
      //    */
      //   if (devices && devices.length) {
      //     console.log('devices', devices)
      //     alert(devices[1].id)
      //     var cameraId = devices[1].id
      //     vue.startCamera(backCamID)
      //   }
      // }).catch(err => {
      //   // handle err
      // });
    },
    startHtml5QrcodeScanner () {
      let self = this

      let bWidth = document.getElementsByClassName('app_body')[0].clientWidth
      let sWidth = document.documentElement.clientWidth
      let sHeight = document.documentElement.clientHeight
      console.log('当前屏幕宽度：', sWidth)
      console.log('当前屏幕高度：', sHeight)

      function isMobileDevice () {
        return window.innerWidth <= 768 // Adjust the threshold value as needed
      }

      self.html5QrcodeScanner = new Html5QrcodeScanner(
        "qr-reader", { 
          fps: 10, 
          qrbox: 350,
          aspectRatio: isMobileDevice()
            ? bWidth / sHeight + 1
            : bWidth / sHeight,
          // aspectRatio:1,
          rememberLastUsedCamera: true,
          useBarCodeDetectorIfSupported: true,
          //showTorchButtonIfSupported: true,
          //showZoomSliderIfSupported: true,
          defaultZoomValueIfSupported: 2,
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
        }
      );
      window.html5QrcodeScanner = self.html5QrcodeScanner
      const onScanSuccess = self.onScanSuccess
      const onScanError = self.onScanError

      self.html5QrcodeScanner.render(onScanSuccess, onScanError);
    },
    startCamera (cameraId) {
      let bWidth = document.getElementsByClassName('app_body')[0].clientWidth
      let sWidth = document.documentElement.clientWidth
      let sHeight = document.documentElement.clientHeight
      console.log('当前屏幕宽度：', sWidth)
      console.log('当前屏幕高度：', sHeight)

      let self = this
      const cameraState = self.html5QrCode.getState()
      const width = document.getElementsByClassName('app_body')[0].clientWidth
      const height = window.innerHeight
      const aspectRatio = width / height
      const reverseAspectRatio = height / width
      const mobileAspectRatio =
        reverseAspectRatio > 1.5
          ? reverseAspectRatio + (reverseAspectRatio * 12) / 100
          : reverseAspectRatio

      console.log('cameraId: ' + cameraId)

      function isMobileDevice () {
        return window.innerWidth <= 768 // Adjust the threshold value as needed
      }

      self.html5QrCode
        .start(
          // !cameraId ? { facingMode: 'environment' } : cameraId,
          { facingMode: 'environment' },
          {
            fps: 10, // frame per seconds for qr code scanning
            aspectRatio: isMobileDevice()
              ? bWidth / sHeight + 1
              : bWidth / sHeight,
            // aspectRatio:1,
            rememberLastUsedCamera: true,
            useBarCodeDetectorIfSupported: true,
            showTorchButtonIfSupported: true,
            showZoomSliderIfSupported: true,
            defaultZoomValueIfSupported: 2
          },
          (decodedText, decodedResult) => {
            // do something when code is read
            // self.pauseCamera()
            console.log('decodedText', decodedText)
            self.scanResult = decodedText
          },
          (errorMessage) => {
            // parse error, ignore it.
            // console.log('parse err', errorMessage)
          }
        )
        .catch((err) => {
          console.log('html5QrCode start err', err)
        })
    },
    clearCamera() {
      let self = this
      try {
        self.html5QrcodeScanner.clear()

        console.log('clearCamera')
      } catch (err) {
        console.log('clearCamera error', err)
      }
    },
    stopCamera () {
      console.log('stopCamera')
      let self = this
      console.log(self.html5QrcodeScanner.getState())
      return self.html5QrcodeScanner.getState() == 2 ? self.html5QrcodeScanner.pause(true) : null
      return self.html5QrCode.stop()
    },
    pauseCamera () {
      console.log('pauseCamera')
      let self = this
      return self.html5QrcodeScanner.getState() == 2 ? self.html5QrcodeScanner.pause(true) : null
      return self.html5QrCode.pause()
    },
    resumeCamera () {
      console.log('resumeCamera')
      let self = this
      return self.html5QrcodeScanner.getState() == 1 ? self.html5QrcodeScanner.resume() : null
      return self.html5QrCode.resume()
    },
    tiaoZhuan () {
      let queryNumber = this.$route.query.expressNumber
      let next = this.$route.query.next
      switch (this.action) {
        case 'parcelInfo':
          this.$router.push({
            name: 'EnterBarcode',
            query: { action: this.action }
          })
          break
        case 'collectingPointStoreExpress':
          // if (this.isNeedScanOtherNumber) {
          if (this.flow === 'WITHOUT_LABEL' && this.step == '2') {
            this.$router.push({
              name: 'EnterBarcode',
              query: {
                action: this.action,
                next,
                otherNumber: this.otherNumber,
                oldScanResult: this.oldScanResult,
                isNeedScanOtherNumber: this.isNeedScanOtherNumber,
                flow: this.flow,
                step: this.step
              }
            })
          } else {
            this.$router.push({
              name: 'EnterBarcode',
              query: {
                action: this.action,
                next,
                flow: this.flow,
                step: this.step
              }
            })
          }
          break
        case 'collectingPointTakeExpress':
          this.$router.push({
            name: 'EnterBarcode',
            query: {
              action: this.action,
              expressNumber: queryNumber,
              pin: this.pin
            }
          })
          break
        case 'merchantTakeExpress':
          let id = this.$route.query.logisticsId
          this.$router.push({
            name: 'EnterBarcode',
            query: { action: this.action, logisticsId: id, next }
          })
          break
        case 'collectExpiredExpress':
          let lid = this.$route.query.logisticsId
          let newLabelNumber = this.$route.query.newLabelNumber
          this.$router.push({
            name: 'EnterBarcode',
            query: {
              action: this.action,
              logisticsId: lid,
              expressNumber: queryNumber,
              next: next,
              newLabelNumber
            }
          })
          break
        default:
          break
      }
    },
    back () {
      if (this.commonJS.isIOS) {
        // this.$router.go(-2)
        this.$router.go(-1)
      } else {
        this.$router.go(-1)
      }
    },
    startMask () {
      this.maskIndex = 2
      this.maskOpacity = 0.5
      this.loading = true
    },
    closeMask () {
      // 关闭蒙版
      // this.startQua()
      this.loading = false
      this.maskIndex = -1
      this.maskOpacity = 0
    },
    displayTip (msg = null) {
      let vue = this
      this.showTip = true
      this.tipMsg = msg
      setTimeout(function () {
        // 关闭提示
        vue.showTip = false
        vue.tipMsg = null
        vue.scanResult = null
        vue.loopCheck()
      }, 1000)
    },
    displaySuccessTip (msg = null) {
      let vue = this
      this.showSuccessTip = true
      this.successTipMsg = msg
      setTimeout(function () {
        // 关闭提示
        vue.showSuccessTip = false
        vue.successTipMsg = null
        vue.scanResult = null
        vue.loopCheck()
      }, 2000)
    },
    // ZXing插件解析条形码
    checkCode (number) {
      let oid = this.orderIdArr.shift()
      this.msg.push('校验ID:' + oid)
      let vue = this
      this.axios({
        method: 'get',
        url: vue.api.parcel + oid,
        timeout: 3000
      }).then(function (response) {
        vue.msg.push('校验结果:' + response.data.ordersId)
        vue.checkedOrderId = response.data.ordersId
      })
    },
    cancel () {
      this.confirmMiniLabel = false
      this.closeMask()
      this.resumeCamera()
      this.scanResult = null
      this.loopCheck()
    },
    confirm () {
      const vue = this
      const data = {
        flow: 'WITHOUT_LABEL',
        expressNumber: vue.otherNumber,
        newLabelNumber: vue.scanResult,
        additionalTrackingNumber: vue.oldScanResult
      }
      this.axios({
        method: 'post',
        url: this.api.collectingPointStoreExpress,
        timeout: 3000,
        data
      })
        .then(function (response) {
          let next = vue.$route.query.next
          let orderId = response.data.ordersId
          let message = 'CustomerStoreSuccess'
          vue.$router.push('/return/success?msg=' + message + '&action=' + vue.action + '&orderId=' + orderId + '&expressNumber=' + response.data.expressNumber + '&next=' + next + '&newOrderNumber=' + vue.scanResult)
        })
        .catch(function (error) {
          vue.resumeCamera()
          vue.closeMask()
          if (error.data.message) {
            // vue.tipMsg = error.data.message
            vue.displayTip(error.data.message)
          } else {
            vue.displayTip('error')
          }
        })
    },
    // 根据路由参数action判断当前页面要执行什么操作
    parseCode () {
      // this.msg.push('正在处理扫码结果')
      const vue = this
      let queryNumber = this.$route.query.expressNumber
      let next = this.$route.query.next
      switch (this.action) {
        // 扫码查询包裹信息
        case 'parcelInfo':
          vue
            .axios({
              method: 'get',
              url: vue.api.parcel + vue.scanResult,
              timeout: 3000
            })
            .then(function (response) {
              vue.checkedOrderId = response.data.ordersId
              // 根据扫码结果执行操作
              vue.$router.push('/order/details?order=' + vue.checkedOrderId + '&logisticsId=' + response.data.deliverMerchantId)
            })
            .catch(function (err) {
              vue.resumeCamera()
              vue.closeMask()
              if (err.data.message) {
                vue.displayTip(err.data.message)
              } else {
                vue.displayTip('Wrong expressNumber:' + vue.scanResult)
              }
            })
          // vue.$router.push('/order/details?order=' + vue.checkedOrderId)
          break
        // 自提点签入 - 存件/退件
        case 'collectingPointStoreExpress':
          let returnMessage = `${this.$t('labeledPackage.returnSuccess')}`
          let data
          // if (vue.isNeedScanOtherNumber) {
          //   if (vue.scanResult.length !== 32) {
          //     vue.closeMask()
          //     vue.resumeCamera()
          //     vue.displayTip(this.$t('barCode.formatnomatch'))
          //     return
          //   }
          //   data = {
          //     expressNumber: vue.otherNumber,
          //     newLabelNumber: vue.scanResult,
          //     additionalTrackingNumber: vue.oldScanResult
          //   }
          // } else {
          //   data = {
          //     expressNumber: vue.scanResult
          //   }
          // }
          if (vue.flow === 'WITH_LABEL') {
            data = {
              flow: 'WITH_LABEL',
              expressNumber: vue.scanResult
            }
          } else if (vue.flow === 'WITHOUT_LABEL') {
            if (vue.step == '1') {
              data = {
                flow: 'WITHOUT_LABEL',
                expressNumber: vue.scanResult
              }
            } else if (vue.step == '2') {
              if (vue.scanResult.length > 255 || vue.scanResult.length < 10) {
                vue.closeMask()
                vue.resumeCamera()
                vue.displayTip(this.$t('barCode.formatnomatch'))
                return
              }
              vue.confirmMiniLabel = true
              return
            }
          }

          // console.log('data', data)
          // return
          this.axios({
            method: 'post',
            url: this.api.collectingPointStoreExpress,
            timeout: 3000,
            data
          })
            .then(function (response) {
              // if (response.data.isNeedScanOtherNumber) {
              if (vue.flow === 'WITHOUT_LABEL' && vue.step == '1') {
                vue.stopCamera()
                vue.isNeedScanOtherNumber = response.data.isNeedScanOtherNumber
                vue.otherNumber = response.data.expressNumber
                vue.oldScanResult = vue.scanResult
                vue.scanResult = ''
                // setTimeout(() => {
                //   vue.resumeCamera()
                //   vue.closeMask()
                //   vue.loopCheck()
                //   vue.startQua()
                // }, 2000)
                vue.$router.push({
                  name: 'Step1SuccessWithoutLabel',
                  query: {
                    flow: vue.flow,
                    step: vue.step,
                    action: vue.action,
                    next: vue.$route.query.next,
                    otherNumber: response.data.expressNumber,
                    oldScanResult: vue.oldScanResult,
                    isNeedScanOtherNumber: response.data.isNeedScanOtherNumber
                  }
                })
              } else if (vue.flow === 'WITHOUT_LABEL' && vue.step == '2') {
                vue.stopCamera()
                let orderId = response.data.ordersId
                let message = 'CustomerStoreSuccess'
                vue.$router.push('/return/success?msg=' + message + '&action=' + vue.action + '&orderId=' + orderId + '&expressNumber=' + response.data.expressNumber + '&next=' + next + '&newOrderNumber=' + vue.scanResult)
              } else {
                let expressNumber = response.data.expressNumber
                // let type = response.data.type
                let message
                // if (type === 'FOR_MERCHANT_STORE') {
                //   message = 'MerchantStoreSuccess'
                // } else if (type === 'FOR_CUSTOMER_STORE') {
                //   message = 'CustomerStoreSuccess'
                // } else {
                //   message = 'Success'
                // }
                message = returnMessage.replace('{{orderId}}', expressNumber)

                vue.displaySuccessTip(message)
                vue.closeMask()
                vue.resumeCamera()
                // vue.$router.push(
                //   '/return/Success?msg=' +
                //     message +
                //     '&action=' +
                //     vue.action +
                //     '&orderId=' +
                //     orderId +
                //     '&expressNumber=' +
                //     response.data.expressNumber +
                //     '&next=' +
                //     next
                // )
              }
            })
            .catch(function (error) {
              vue.resumeCamera()
              vue.closeMask()
              if (error.data.message) {
                // vue.tipMsg = error.data.message
                vue.displayTip(error.data.message)
              } else {
                vue.displayTip('error')
              }
            })
          break
        // 取件 - 扫码签出给客户
        case 'collectingPointTakeExpress':
          // let queryNumber = this.$route.query.expressNumber
          if (queryNumber !== vue.scanResult) {
            vue.closeMask()
            vue.displayTip(this.$t('barCode.mismatch'))
            vue.resumeCamera()
            return false
          }
          // vue.$router.push(`/return/identity?barcode=${vue.scanResult}&action=collectingPointTakeExpress`)
          vue.$router.push({
            path: '/return/identity',
            query: {
              action: 'collectingPointTakeExpress',
              expressNumber: queryNumber,
              pin: vue.pin
            }
          })
          // vue.axios({
          //   method: 'post',
          //   url: vue.api.collectingPointTakeExpress,
          //   timeout: 3000,
          //   data: {
          //     expressNumber: vue.scanResult,
          //     pinCode: this.pin,
          //     type: 'FOR_CUSTOMER_TAKE'
          //   }
          // }).then(function (response) {
          //   // let ordersId = response.data.ordersId
          //   let message = 'CollectSuccess'
          //   vue.$router.push('/return/success?msg=' + message + '&action=collectingPointTakeExpress')
          // }).catch(function (error) {
          //   vue.closeMask()
          //   vue.resumeCamera()
          //   if (error.data.message) {
          //     vue.tipMsg = error.data.message
          //     vue.displayTip(error.data.message)
          //   }
          // })
          break
        // 扫码 - 收用户退件
        case 'merchantTakeExpress':
          if (queryNumber && (queryNumber !== vue.scanResult)) {
            vue.closeMask()
            vue.displayTip(this.$t('barCode.mismatch'))
            vue.resumeCamera()
            return false
          }
          let logisticsIda = vue.$route.query.logisticsId
          // alert(logisticsIda)
          vue
            .axios({
              method: 'post',
              url: vue.api.merchantTakeExpress,
              timeout: 3000,
              data: {
                type: 'FOR_CUSTOMER_STORE',
                expressNumber: vue.scanResult,
                logisticsId: logisticsIda
              }
            })
            .then(function (response) {
              vue.$router.push(
                '/return/success?msg=ReturnSuccess' +
                  '&action=merchantTakeExpress' +
                  '&expressNumber=' +
                  response.data.expressNumber +
                  '&logisticsId=' +
                  logisticsIda +
                  '&next=' + next
              )
            })
            .catch(function (error) {
              vue.closeMask()
              vue.resumeCamera()
              if (error.data.message) {
                vue.tipMsg = error.data.message
                vue.displayTip(error.data.message)
              }
            })
          break
        // 扫码 - 收逾期件 -给物流
        case 'collectExpiredExpress':
          const newLabelNumber = vue.$route.query.newLabelNumber
          if ((queryNumber && (queryNumber !== vue.scanResult)) && newLabelNumber !== vue.scanResult) {
            vue.closeMask()
            vue.displayTip(this.$t('barCode.mismatch'))
            vue.resumeCamera()
            return false
          }
          // 先查出物流ID
          let logisticsId = vue.$route.query.logisticsId
          // alert(logisticsId)
          vue
            .axios({
              method: 'post',
              url: this.api.collectExpiredExpress,
              timeout: 3000,
              data: {
                expressNumber: vue.scanResult,
                type: 'FOR_MERCHANT_STORE',
                logisticsId: logisticsId
              }
            })
            .then(function (response) {
              vue.$router.push(
                '/return/success?msg=ReturnSuccess' +
                  '&action=collectExpiredExpress' +
                  '&expressNumber=' +
                  response.data.expressNumber +
                  '&logisticsId=' +
                  logisticsId +
                  '&next=' + next
              )
            })
            .catch(function (error) {
              vue.resumeCamera()
              vue.closeMask()
              if (error.data.message) {
                vue.tipMsg = error.data.message
                vue.displayTip(error.data.message)
              }
            })
          break
        case 'scanNote':
          let from = this.$route.query.from
          let orderId = this.$route.query.orderId
          if (!orderId) {
            vue.resumeCamera()
            vue.closeMask()
            vue.displayTip('orderId Not Found')
            this.$router.back()
            return false
          }
          let msg = this.$route.query.msg
          if (from === 'Details') {
            let logisticsId = vue.$route.query.logisticsId
            if (vue.original_action) {
              vue.$router.push(
                'order/details?order=' +
                  orderId +
                  '&scanNote=' +
                  vue.scanResult +
                  '&original_action=' +
                  vue.original_action +
                  '&logisticsId=' +
                  logisticsId
              )
            } else {
              vue.$router.push(
                'order/details?order=' + orderId + '&scanNote=' + vue.scanResult
              )
            }
          } else {
            const next = vue.$route.query.next
            if (vue.original_action) {
              vue.$router.push(
                '/return/success?msg=' +
                  msg +
                  '&orderId=' +
                  orderId +
                  '&action=' +
                  vue.action +
                  '&original_action=' +
                  vue.original_action +
                  '&scanNote=' +
                  vue.scanResult +
                  '&logisticsId=' +
                  logisticsId +
                  '&expressNumber=' +
                  vue.$route.query.expressNumber +
                  '&next=' +
                  next
              )
            } else {
              vue.$router.push(
                '/return/success?msg=' +
                  msg +
                  '&orderId=' +
                  orderId +
                  '&action=' +
                  vue.action +
                  '&scanNote=' +
                  vue.scanResult +
                  '&expressNumber=' +
                  vue.$route.query.expressNumber +
                  '&next=' +
                  next
              )
            }
          }
          break
        default:
          // this.msg.push('未知的操作')
          alert('Unknown operation')
          this.$router.push('/')
          break
      }
      return false
    }
  }
}
</script>
<style>
#qr-reader {
  background: transparent !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  border: 0px !important;
  z-index: -1;
}
#html5-qrcode-anchor-scan-type-change {
  display: none !important;
}
#qr-reader__dashboard {
  position: absolute;
  top: 80px;
}
#qr-shaded-region {
  opacity: 0 !important;
}
#html5-qrcode-select-camera,
#html5-qrcode-button-camera-start,
#html5-qrcode-button-camera-stop {
  background-color: #fff;
  color: var(--primary-inverted-button-text-color);
  margin: 0.02rem auto;
  padding: 0 0.1rem;
  height: 0.2rem;
  background: rgba(255, 255, 255, 1);
  -webkit-box-shadow: 0rem 0rem 0rem rgba(0, 0, 0, 0.16);
  box-shadow: 0rem 0rem 0rem rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 0.42rem;
  text-align: center;
}
#html5-qrcode-select-camera:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background-color: darkgray;
}
</style>
<style scoped>
.containers {
  position: relative;
}

.loading {
  position: absolute;
  z-index: 3;
  color: #fff;
  font-weight: 400;
  /* font-size: 0.4rem; */
  font-size: 46px;
  /* top: 3.5rem; */
  /* left: 1rem; */
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loading-spinner {
  -webkit-animation: spin 1.5s linear infinite;
  -moz-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;
}

.mask {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  z-index: -1;
  background: #000;
  opacity: 0;
  transition: opacity 0.5s ease;
  -moz-transition: opacity 0.5s ease;
  -webkit-transition: opacity 0.5s ease;
  -ms-transition: opacity 0.5s ease;
}

.none {
  display: none;
}

#msg {
  color: blue;
}

.tip-content {
  padding: 0.71rem 0.1rem 0 0.13rem;
  width: 92%;
  height: 0.28rem;
  font-size: 0.2rem;
  font-weight: 100;
  line-height: 0.24rem;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  text-align: center;
  font-family: "Poppins-Regular";
  margin-top: 20px;
  white-space: pre-line;
}

#video video {
  height: 100% !important;
}

#video {
  position: fixed;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: #000;
  z-index: -2;
}

.content {
  width: 100%;
  /*height: calc(100vh);*/
  /*overflow: hidden;*/
  z-index: 1;
}

.manually {
  margin: 0.7rem 0.1rem 0rem auto;
  width: 92%;
  height: 0.28rem;
  font-size: 0.2rem;
  font-family: Rubik;
  font-weight: 900;
  line-height: 0.24rem;
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
  opacity: 1;
  text-align: center;
}

.back {
  margin-bottom: 0.1rem;
  margin-left: auto;
  margin-right: auto;
  width: 82%;
  height: 0.58rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0rem rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 0.42rem;
  text-align: center;
}

.back-top {
  margin-top: 1.5rem;
}

.scan-box {
  width: 80%;
  height: 2.7rem;
  margin-top: 0.57rem;
  margin-left: auto;
  margin-right: auto;
  border: 0.03rem solid #fff;
  border-radius: 0.17rem;
  box-shadow: 0 0 0.09rem 0 #fff inset;
}

.scan-line {
  margin: 0 auto;
  width: 2rem;
  background: #fff;
  height: 0.03rem;
  box-shadow: 0 0 0.09rem 0 #fff;
  position: relative;
  top: 1.3rem;
}

.manually {
  /*margin: 0.7rem 0.1rem 0.2rem auto;*/
  /*width: 92%;*/
  margin-top: 0.7rem;
  /*margin-bottom: 0.2rem;*/
  text-align: center;
  height: 0.28rem;
  font-size: 0.2rem;
  font-family: "Poppins-Regular";
  font-weight: 900;
  line-height: 0.24rem;
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
  opacity: 1;
}

.back {
  margin: 0.2rem auto;
  /*margin-top: 0.2rem;*/
  /*margin-bottom: 0.1rem;*/
  /*margin-left: auto;*/
  /*margin-right: auto;*/
  width: 82%;
  height: 0.58rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0rem rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 0.42rem;
  text-align: center;
}

.back-font {
  text-align: center;
  width: 0.49rem;
  height: 0.24rem;
  font-size: 0.2rem;
  font-weight: bold;
  line-height: 0.58rem;
  /* color: rgba(5, 36, 96, 1); */
  color: var(--primary-inverted-button-text-color);
  opacity: 1;
  font-family: Rubik-Bold;
  font-weight: 400;
}

#canvas {
  display: none;
}

/* .tip-msg {
    z-index: 3;
    position: fixed;
    top: 0.1rem;
    width: 90%;
    margin-left: 2%;
    background: #FF0000;
    border-radius: 0.05rem;
    color: #fff;
    font-weight: 400;
    padding: 0.1rem;
    font-size: 0.15rem;
    text-align: center;
    max-width: 400px;
  } */
.containers {
  height: 100vh;
  height: 100svh;
  height: 100dvh;
}

.confirmMiniLabel{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95%;
  box-sizing: border-box;
  background: white;
  border-radius: 0.1rem;
  padding: 0.2rem;
  text-align: center;
  z-index: 100;
}
.confirmMiniLabel div{
  width: 100%;
  margin: 0.1rem 0 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.details_bt_w {
    width: 40%;
    height:0.40rem;
    /* background: rgba(255, 255, 255, 1); */
    background: var(--primary-inverted-button-bg-color);
    box-shadow:0rem 0.05rem 0.1rem rgba(0,0,0,0.16);
    opacity: 1;
    border-radius:0.30rem;
    border: none;
    /* color: rgba(5, 36, 96, 1); */
    color: var(--primary-inverted-button-text-color);
    line-height:0.235rem;
    font-size:0.14rem;
    /*font-weight: bold;*/
    font-family: Poppins-Bold;
}
.details_bt_b {
    width: 40%;
    height:0.40rem;
    /* background:linear-gradient(113deg,rgba(5,36,96,1) 0%,rgba(31,157,197,1) 100%); */
    /* background: linear-gradient(to right, #191E96 , #00BEF5 ); */
    background: var(--primary-button-bg-color);
    box-shadow:0rem 0.05rem 0.1rem rgba(5,36,96,0.3);
    border-radius:0.30rem;
    border: none;
    color: #ffffff;
    line-height:0.235rem;
    font-size:0.14rem;
    /*font-weight: bold;*/
    font-family: Poppins-Bold;
}
.stepper-container {
  display: flex;
  align-items: center; 
  justify-content: center;
  z-index: 99;
}
.stepper-text {
  font-size: 0.12rem;
  color: rgba(255, 255, 255, 1);
  padding-left: 5px;
}
.stepper-line {
  min-width: 36px;
  height: 0.01rem;
  margin: 0 5px;
  background-color: rgba(255, 255, 255, 1);
}
.circle {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: #E6E6E6;
    display: flex;
    align-items: center; 
    justify-content: center;
    color: #666666;
    font-size: 0.12rem;
    font-weight: bold;
    font-family: Arial, sans-serif;
}
.circle.active {
  background-color: #0055FF;
  color: white;
}
.circle.completed {
  background-color: #D1E3FF;
  color: white;
}
.tip-content-bottom {
  padding: 0.16rem 0.1rem 0 0.13rem;
  width: 92%;
  height: 0.28rem;
  font-size: 0.2rem;
  font-weight: 700;
  line-height: 0.24rem;
  color: white;
  opacity: 1;
  text-align: center;
  font-family: "Poppins-Regular";
  margin-top: 20px;
  white-space: pre-line;
}
#c-control {
  position: absolute;
  z-index: 1;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BarcodeWithoutLabel.vue